import {ReactNode} from "react"

export default function FormTitle(props: {
    heading: string | ReactNode
    description?: string | ReactNode
}) {
    return <div className="form-title">
        <div className="heading">{props.heading}</div>
        {props.description &&
            <div className="description">{props.description}</div>
        }
    </div>
}
